/* eslint-disable @next/next/no-img-element */
"use client";
import Link from "next/link";


interface IPostsData {
  title?: string;
  imgUrl?: string;
  href?: string;
  desc?: string;
  className?: string;
  SlideWidth?: string;
  style?: any;
}

export default function SingleTrendingPost(props: IPostsData) {
  const { title = "", imgUrl = "", className = "", SlideWidth, href="" } = props;
  return (
    <Link className="text-left" href={href}>
      <figure
        className={`rounded-xl overflow-hidden h-72 w-full lg:mb-4 mb-3 ${className}`}
      >
        <img loading="lazy" className="w-full h-full object-cover" src={imgUrl} alt="" />
      </figure>
      <h3 className="text-primary-800 xl:text-2xl lg:text-xl text-lg   font-normal">{title}</h3>
    </Link>
  );
}
